import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductInformation } from '../../equipment.models';
import { buildWebShopLink } from '@app/core/utils';
import { AppData } from '@app/shared/models/appdata.model';
import { HardwareVariantOfferingDetails } from '@app/sales/modules/accessories/models/hardware-offering-model';

@Component({
  selector: 'app-equipment-dialog-product-information',
  templateUrl: './equipment-dialog-product-information.component.html',
  styleUrl: './equipment-dialog-product-information.component.scss',
  imports: [CommonModule],
})
export class EquipmentDialogProductInformationComponent {
  private appData = inject(AppData);

  @Input() hardwareDetails: HardwareVariantOfferingDetails;

  private readonly unidentifiedProductName = 'Ukjent produkt';

  get isIllustration(): boolean {
    return this.hardwareDetails.image.downloadUri.endsWith('.svg');
  }

  get productInformation(): ProductInformation {
    const { image, manufacturer, name, keyInformation, groupSlug } = this.hardwareDetails ?? {};

    return {
      imageSource: image?.downloadUri,
      manufacturer: manufacturer,
      name: name ?? this.unidentifiedProductName,
      uniqueSellingPoints: keyInformation,
      additionalInformationUrl: buildWebShopLink(this.appData.webShopBaseUrl, groupSlug, manufacturer),
    } as ProductInformation;
  }
}
